import { ChildProps } from '@apollo/client/react/hoc';
// TODO update this to import from commons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';

import { CoreListingSimilarListings } from '@reverbdotcom/commons/src/gql/graphql';
import SimilarListingsRow, { SimilarListingsFragment } from './similar_listings_row';

import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import { localizeSimilarListingsFilters } from '@reverbdotcom/commons/src/localize_listing_rows_utils';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';

interface ExternalProps {
  listingId: string
  tilesFourWideMax?: boolean;
  largeTiles?: boolean;
  title?: string;
  showFlags: boolean;
}

type IProps = ChildProps<ExternalProps & IUserContext, CoreListingSimilarListings.Query>;

export function SimilarListingsRowWithQuery(props: IProps) {
  const shouldRender = !props.data.loading;

  if (!shouldRender) { return null; }

  const { title } = props;

  return (
    <SimilarListingsRow
      similarListings={props.data.listing?.similarListings}
      title={title}
      showFlags={props.showFlags}
    />
  );
}

const withQuery = withGraphql<IProps, CoreListingSimilarListings.Query>(
  gql`
    query Core_Listing_SimilarListings(
      $listingId: String
      $itemRegion: String,
      $itemRegionRelation: reverb_search_ListingItemRegionRelation
    ) {
      listing(input: {
        id: $listingId
      }) {
        _id
        similarListings(
          input: {
            includeForLiveListings: true,
            itemRegion: $itemRegion,
            itemRegionRelation: $itemRegionRelation,
            limit: 10,
          }
        ) {
          _id
          ...SimilarListingsFields
        }
      }
    }
    ${SimilarListingsFragment}
  `,
  {
    options: (ownProps) => {

      return {
        ssr: false,
        errorPolicy: 'all',
        variables: {
          listingId: ownProps.listingId,
          ...localizeSimilarListingsFilters(ownProps.user),
        },
      };
    },
  },
);

export default withUserContext(withQuery(SimilarListingsRowWithQuery));
